// ============================================================
// Stick It Shop — Borduurwerk Upload Handler
// Versie 2.0 — CORS workaround via fetch no-cors + doGet
// Laad dit bestand via:
// {{ 'borduurwerk-upload.js' | asset_url | script_tag }}
// ============================================================

(function() {

  var UPLOAD_CONFIG = {
    // ⚠️ VERVANG DIT MET JOUW GEHEIME SLEUTEL
    SLEUTEL: 'MDgyvBHnkn2ZH82GtWsGRRkzukGZ6',
    URL: 'https://script.google.com/macros/s/AKfycbxZN4tK4yp8bkVDvKZIktA8rbXFlaE_HgZqGuC98qM8wp0sIoSSw1ztBNBzx3PeO-scNw/exec',
    MAX_MB: 20,
    TOEGESTANE_EXTENSIES: ['jpg', 'jpeg', 'png', 'svg', 'pdf', 'ai', 'eps']
  };

  // ============================================================
  // Hoofdfunctie upload
  // Gebruik: BorduurwerkUpload.upload(inputElement, 'Voorkant logo', callbackFunctie)
  // ============================================================
  window.BorduurwerkUpload = {

    upload: function(inputEl, positie, callback) {
      var bestand = inputEl.files[0];
      if (!bestand) return;

      // 1. Valideer extensie
      var extensie = bestand.name.split('.').pop().toLowerCase();
      if (UPLOAD_CONFIG.TOEGESTANE_EXTENSIES.indexOf(extensie) === -1) {
        callback({ success: false, error: 'Bestandstype niet toegestaan. Gebruik: ' + UPLOAD_CONFIG.TOEGESTANE_EXTENSIES.join(', ') });
        return;
      }

      // 2. Valideer grootte
      var groottteMB = bestand.size / (1024 * 1024);
      if (groottteMB > UPLOAD_CONFIG.MAX_MB) {
        callback({ success: false, error: 'Bestand te groot. Maximum is ' + UPLOAD_CONFIG.MAX_MB + 'MB.' });
        return;
      }

      // 3. Lees bestand als base64
      var reader = new FileReader();
      reader.onload = function(e) {
        var base64 = e.target.result.split(',')[1];

        // 4. Stuur via fetch met no-cors workaround
        // Apps Script vereist GET parameters voor no-cors uploads
        // We sturen de data via een URL-encoded POST naar een proxy endpoint
        var payload = {
          action: 'upload',
          sleutel: UPLOAD_CONFIG.SLEUTEL,
          bestandNaam: bestand.name,
          bestandData: base64,
          mimeType: bestand.type,
          positie: positie
        };

        // Gebruik XMLHttpRequest met callback voor betere error handling
        var xhr = new XMLHttpRequest();
        xhr.open('POST', UPLOAD_CONFIG.URL, true);
        xhr.setRequestHeader('Content-Type', 'text/plain'); // text/plain vermijdt CORS preflight
        xhr.onload = function() {
          try {
            var data = JSON.parse(xhr.responseText);
            callback(data);
          } catch(e) {
            callback({ success: false, error: 'Ongeldig antwoord van server.' });
          }
        };
        xhr.onerror = function() {
          callback({ success: false, error: 'Upload mislukt. Controleer je verbinding en probeer opnieuw.' });
        };
        xhr.send(JSON.stringify(payload));
      };

      reader.onerror = function() {
        callback({ success: false, error: 'Bestand kon niet worden gelezen.' });
      };

      reader.readAsDataURL(bestand);
    },

    koppelOrder: function(ordernummer, uploadIds) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', UPLOAD_CONFIG.URL, true);
      xhr.setRequestHeader('Content-Type', 'text/plain');
      xhr.send(JSON.stringify({
        action: 'koppelOrder',
        sleutel: UPLOAD_CONFIG.SLEUTEL,
        ordernummer: ordernummer,
        uploadIds: uploadIds
      }));
    }
  };

})();